import React from "react";

import { STATIC_KEYWORDS } from "../../constants";
import { DfpComponent } from "../ads/dfp-component";
import {
  AppLogo,
  Button,
  HeaderMenuItem,
  Headline,
  NavSubMenu,
  PublishDateAndTime,
  ReadTime,
  StoryAuthors,
} from "../atoms";
import { MenuWithDropdown, StoryHeader } from "../molecules";

import "./atom-ref.m.css";

export const AtomReference = () => {
  const { SIGN_IN, GO_AD_FREE } = STATIC_KEYWORDS;
  const tabl = (Author, AtomName, AtomDescription, Atom) => {
    return (
      <div styleName="atom-container">
        <h1>Author: {Author}</h1>
        <hr />
        <h2>Atom Name: {AtomName}</h2>
        <hr />
        <h2>Atom Description: {AtomDescription}</h2>
        <hr />
        <table styleName="atom-table">
          <thead>
            <tr>
              <th>Atom Name</th>
              <th>Atom UI</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{AtomName}</td> {/* Using template literals */}
              <td>{Atom}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const fullWidthComponent = (author, atomName, component) => {
    return (
      <div className="container" styleName="fullWidthComponents">
        <div styleName="inner-div">
          <div>Author: {author}</div>
          <div>Component Name: {atomName}</div>
        </div>
        {component}
      </div>
    );
  };

  const storyAuthor = [
    {
      slug: "fortuneindia-com",
      social: {},
      name: "Jess Bidgood",
      "contributor-role": null,
      "avatar-url": null,
      bio: null,
      id: 1600536,
      "avatar-s3-key": null,
      "twitter-handle": null,
    },
    {
      slug: "quintype-technologies",
      social: {},
      name: "Zack Beauchamp",
      "contributor-role": null,
      "avatar-url": null,
      bio: null,
      id: 1600537,
      "avatar-s3-key": null,
      "twitter-handle": null,
    },
    {
      slug: "quintype-services",
      social: {},
      name: "John Doe",
      "contributor-role": null,
      "avatar-url": null,
      bio: null,
      id: 1600537,
      "avatar-s3-key": null,
      "twitter-handle": null,
    },
  ];

  return (
    <>
      {fullWidthComponent(
        "Bhupesh Kumawat",
        "Story Header Molecule",
        <StoryHeader
          storyAuthorData={storyAuthor}
          headline="How a Trump Comeback Could Impact India's Markets and IT Sector"
          readTime={5}
          publishTime={1734450441084}
        />
      )}
      {fullWidthComponent(
        "Bhupesh Kumawat",
        "Story Header Molecule",
        <StoryHeader
          storyAuthorData={storyAuthor}
          showAd={false}
          headline="How a Trump Comeback Could Impact India's Markets and IT Sector"
          readTime={5}
          publishTime={1734450441084}
        />
      )}
      <div className="container">
        {tabl("SANJEEV", "READ TIME", "READ TIME ATOM", <ReadTime time={"5"} />)}
        {tabl(
          "Suhail Khan",
          "Headline Atom",
          "All the variation of headline based on type props eg:1,2,3,4,5,6",
          <>
            <Headline type={1}>h1 heading</Headline>
            <hr />
          </>
        )}

        {tabl(
          "Suhail Khan",
          "Story Authors Atom",
          "Story Authors Names",
          <StoryAuthors storyAuthor={storyAuthor} customStyleName={"authors-name"} />
        )}

        {tabl(
          "SANJEEV",
          "PUBLISH DATE AND TIME",
          "PUBLISH DATE AND TIME",
          <PublishDateAndTime publishTime={1734450441084} />
        )}

        {tabl(
          "Bhupesh",
          "Button",
          "Button atom",
          <div style={{ display: "flex", gap: "8px" }}>
            <Button ariaLabel="Sign in button">{SIGN_IN}</Button>
            <Button ariaLabel="Go ad-free button" customStyleName="bg-brand-primary">
              {GO_AD_FREE}
            </Button>
          </div>
        )}

        {tabl(
          "Sanjeev",
          "Ads",
          "Advertisement for 200x250 slot",
          <>
            <h1>With Text 300 X 250 slot</h1>
            <br />
            <DfpComponent adStyleName="ad-slot-size-300x250" id="Ad-1" adSlotConfigName="300x250_ad_slot" />
            <hr />
            <h1>Without Text 300 x 250 slot</h1>
            <br />
            <DfpComponent
              adStyleName="ad-slot-size-300x250"
              id="Ad-2"
              adSlotConfigName="300x250_ad_slot"
              showText={false}
            />
            <hr />
            <h1>With Text 728 X 90 slot</h1>
            <br />
            <DfpComponent adStyleName="ad-slot-size-728x90-300x250" id="Ad-3" adSlotConfigName="728x90_ad_slot" />
            <hr />
            <h1>Without Text 728 x 90 slot</h1>
            <br />
            <DfpComponent
              adStyleName="ad-slot-size-728x90-300x250"
              id="Ad-7"
              adSlotConfigName="728x90_ad_slot"
              showText={false}
            />
          </>
        )}
        {tabl("Phaneendra", "Logo", "Logo atom for all the devices", <AppLogo />)}
        {tabl(
          "Bhupesh",
          "Menu With Dropdown",
          "Menu With Dropdown molecule",
          <div style={{ display: "flex", gap: "20px" }}>
            <MenuWithDropdown
              subMenuitems={[
                {
                  menuItemName: "fortune500",
                  menuItemLink: "abc.com",
                },
                {
                  menuItemName: "fortune 40 item 40n sd sd sd sd sds ds s d",
                  menuItemLink: "abcd.com",
                },
                {
                  menuItemName: "fortune 60 item 40",
                  menuItemLink: "abcd.com",
                },
                {
                  menuItemName: "fortune 40 item 50",
                  menuItemLink: "abcd.com",
                },
              ]}
            />
            <MenuWithDropdown menuItemvalue="Magazine" />
          </div>
        )}
        {tabl(
          "Bhupesh",
          "Header Menu Item",
          "Header Menu Item Atom",
          <div style={{ display: "flex", gap: "20px" }}>
            <HeaderMenuItem />
            <HeaderMenuItem isIconNeeded={false} />
          </div>
        )}
        {tabl(
          "Sanjeev",
          "Navigation Sub Menu",
          "Navigation Sub Menu Atom accepts Array of object containing  menuItemName and menuItemLink, refer atom-ref.js for more details",
          <NavSubMenu
            subMenuitems={[
              {
                menuItemName: "fortune500",
                menuItemLink: "abc.com",
              },
              {
                menuItemName: "fortune 40 item 40",
                menuItemLink: "abcd.com",
              },
              {
                menuItemName: "fortune 60 item 40",
                menuItemLink: "abcd.com",
              },
              {
                menuItemName: "fortune 40 item 50",
                menuItemLink: "abcd.com",
              },
            ]}
          />
        )}
      </div>
    </>
  );
};
